export default function hasSlot(this: Vue, name = 'default'): boolean {
  return (
    this.$slots[name] !== undefined || this.$scopedSlots[name] !== undefined
  )
}
